import type from '../actions/types';
import { AuthorizationState } from '../../models/interfaces';
import { ActionType } from '../../models/types';

const INITIAL_STATE: AuthorizationState = {
  token: '',
  authType: '',
  pageTitle: '',
  isLoading: true,
}

function reducer(state: AuthorizationState = INITIAL_STATE, action: ActionType) {
  switch (action.type) {
    case type.SET_TOKEN:
      return {
        ...state,
        token: action.payload
      };
    case type.SET_AUTH_TYPE:
      return {
        ...state,
        authType: action.payload
      };
    case type.SET_PAGE_TITLE:
      return {
        ...state,
        pageTitle: action.payload
      };
    case type.SET_LOADING_TOKEN:
      return {
        ...state,
        isLoading: action.payload
      };
    default:
      return state;
  }
}

export default reducer;